import { Component, ContentChild, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CriteriaAddComponent } from '../criteria/criteria.add.component';
import { VisionService } from '../services/vision.service';
import { User } from '../models/dto/user';
import { SurveyTypes } from '../models/surveytypes';
import { SurveyDetails } from '../models/dto/survey';

@Component({
    selector: 'vision-selected-nodes',
    template: `<div class="container-fluid">
    <div class="row-strip-opac"></div>
    <div class="row mt-5">
          <div class="col-md-2 text-right">
          <span class="h5 font-weight-normal text-white">Vision à :</span>
          </div>
          <div class="col-md-8">
                  <div class="row table-radios-strip">
                      <div class="table-td-strip radio-strip">

                      <label class="role-strip custom-control custom-radio" for="one"  [ngClass]="vision_selected1 && visionTypeSelected != 1 ? 'rad-fake-dot':''">
                      <input type="radio" name="radio" id="one" value="1" [checked]="visionTypeSelected == 1" (click)="selectRadio(1)" [disabled]="!vision_selected1">
                      <span class="custom-control-description font-weight-bold"  [class.text-white]="visionTypeSelected == 1">3 MOIS</span>
                      </label>
                      <div class="radio-line1"></div>

                      <label class="role-strip custom-control custom-radio" for="one" [ngClass]="vision_selected2 && visionTypeSelected != 2 ? 'rad-fake-dot':''">
                      <input type="radio" name="radio" id="one" value="2" [checked]="visionTypeSelected == 2" (click)="selectRadio(2)" [disabled]="!vision_selected2">
                      <span class="custom-control-description font-weight-bold"  [class.text-white]="visionTypeSelected == 2">1 AN</span>
                      </label>
                      <div class="radio-line2"></div>
                      
                      <label class="role-strip custom-control custom-radio" for="one" [ngClass]="vision_selected3 && visionTypeSelected != 3 ? 'rad-fake-dot':''">
                      <input type="radio" name="radio" id="one" value="3" [checked]="visionTypeSelected == 3" (click)="selectRadio(3)" [disabled]="!vision_selected3">
                      <span class="custom-control-description font-weight-bold"  [class.text-white]="visionTypeSelected == 3">3 ANS</span>
                      </label>
                      <div class="radio-line3"></div>

                      <label class="role-strip custom-control custom-radio" for="one" [ngClass]="vision_selected4 && visionTypeSelected != 4 ? 'rad-fake-dot':''">
                      <input type="radio" name="radio" id="one" value="4" [checked]="visionTypeSelected == 4" (click)="selectRadio(4)" [disabled]="!vision_selected4">
                      <span class="custom-control-description font-weight-bold"  [class.text-white]="visionTypeSelected == 4">10 ANS</span>
                      </label>

                      </div>
                  </div>
      </div>
              <div class="col-md-2 text-left">
                  <span class="font-weight-normal"><a href="javascript:;" (click)="modifyVision()" class="ln-modify text-white small">MODIFIER</a></span>
              </div>
      <div class="col-md-12"><div class="hr-top"></div></div>
    </div>
    </div>
`,
    styleUrls: ['./vision.strip.template.scss'],
})
export class VisionsStripTemplateComponent {
    @Output() radioSelected: EventEmitter<string> = new EventEmitter<string>();

    visionTypeSelected: number;
    email: string;
    user_data: any;
    user_surveys: Array<SurveyDetails> = [];
    selectedModifyVision = 0;
    enableModify = false;
    vision_selected1 = false; vision_selected2 = false; vision_selected3 = false; vision_selected4 = false;

    constructor(private visionService: VisionService, private surveyTypes: SurveyTypes, private router: Router) {
        const typeId = surveyTypes.getTitleId(localStorage.getItem('vision_title'));
        this.visionTypeSelected = typeId;

        this.email = localStorage.getItem('email');
        this.visionService.getUserVisions(this.email).subscribe(result => {
            this.user_data = result.User;
            this.user_surveys = this.user_data.surveys;
            this.checkSelectedVisions();
        });

    }

    checkSelectedVisions() {
        if (this.user_surveys) {
            let selectedVision = this.surveyTypes.getTitle(1);
            let isExist = this.user_surveys.filter(x => x.title === selectedVision);
            if (isExist.length > 0) {
                this.vision_selected1 = true;
            }
            selectedVision = this.surveyTypes.getTitle(2);
            isExist = this.user_surveys.filter(x => x.title === selectedVision);
            if (isExist.length > 0) {
                this.vision_selected2 = true;
            }
            selectedVision = this.surveyTypes.getTitle(3);
            isExist = this.user_surveys.filter(x => x.title === selectedVision);
            if (isExist.length > 0) {
                this.vision_selected3 = true;
            }
            selectedVision = this.surveyTypes.getTitle(4);
            isExist = this.user_surveys.filter(x => x.title === selectedVision);
            if (isExist.length > 0) {
                this.vision_selected4 = true;
            }
        }

    }
    selectRadio(value) {
        if (value === 1 && this.vision_selected1) {
            this.enableModify = true;
        } else if (value === 2 && this.vision_selected2) {
            this.enableModify = true;
        } else if (value === 3 && this.vision_selected3) {
            this.enableModify = true;
        } else if (value === 4 && this.vision_selected4) {
            this.enableModify = true;
        } else {
            this.enableModify = false;
        }
        this.selectedModifyVision = value;
        this.radioSelected.emit(value);
    }
    modifyVision() {
        if (this.enableModify) {
            this.router.navigateByUrl('vision/editcriterias;visiontype=' + this.selectedModifyVision);
        }
    }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/vision/visions.strip.template.ts